Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.UserFilterView extends Backbone.View
  template: JST["backbone/templates/monitoring/filters/user/user_filter"]

  events:
    'click #apply-user': 'filter'
    'click .select_all_filter': 'selectAllFilters'
    'click .filter-title': 'onToggleExpand'



  initialize: (@options = {}) ->
    @searchQuery = @options.searchQuery
    @facet = @options.facet

  destroy: () ->
    this.remove()
    return false

  render: ->
    @$el.html(@template(searchQuery: @searchQuery))
    return this

  selectAllFilters: (event) =>
    event.stopPropagation()
    checkbox = @$el.find('input[type=checkbox]')
    if @$el.find('input[type=checkbox]:checked').length == checkbox.length
      checkbox.prop('checked', false)
    else
      checkbox.prop('checked', true)

  onToggleExpand: =>
    if @$el.find('.filter').hasClass('expanded')
      @$el.find('.select_all_filter').addClass('hidden')
    else
      @$el.find('.select_all_filter').removeClass('hidden')

  filter: (event) =>
    _.each @$el.find("#user").val().trim().split(','), (user) =>
      user = user.trim()
      if user.indexOf('@') == 0
        user = user.substr(1)
      if user.length > 0
        @searchQuery.addUser(user)

    klout_checked = @$el.find('#influencers').get(0).checked
    @searchQuery.setFilterByKlout(klout_checked)

    list_checked = @$el.find('#influencer_list').get(0).checked
    @searchQuery.setFilterByInfluencerList(list_checked)

    @eventAggregator.trigger('searchQueryChanged', @searchQuery)
